<template>
  <v-form ref="userForm" lazy-validation>

    <v-container fluid class="pt-0 mt-0">
      <v-row>
        <v-spacer />
        <v-col cols="10">
          <h1>{{ addOrEditLabel }} News Item</h1>
          <br />
          <v-text-field label="What is the title of the news article?"
            hint="The title should be no more than 150 characters" counter="150" v-model="newsArticleTitle"
            :rules="titleRules">
          </v-text-field>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row>
        <v-spacer />
        <v-col cols="10">
          <div class="editor">
            <h2>Your Article Goes Here</h2>
            <editor ref="editorElement" api-key="obkrlht14x57mdol58bxqewvhlp88c5lwfj2i9d770gpxomq" initial-value="<br/>"
              v-model="editorContent" id="contentEditor" :init="{
                selector: 'textarea',
                height: 360,
                menubar: false,
                toolbar_mode: 'wrap',
                mobile: {
                  toolbar_mode: 'wrap',
                },
                style_formats: [
                  {
                    title: 'Image Left',
                    selector: 'img',
                    styles: {
                      float: 'left',
                      margin: '0 10px 0 10px',
                    },
                  },
                  {
                    title: 'Image Right',
                    selector: 'img',
                    styles: {
                      float: 'right',
                      margin: '0 10px 0 10px',
                    },
                  },
                ],
                setup: function (editor) {
                  editor.on('init', function (e) {
                    focusEditor(e);
                    editor.execCommand('mceFocus');
                  });
                },
                plugins: ['emoticons', 'lists', 'advlist', 'link', 'anchor', 'image', 'media'],
                toolbar:
                  'undo redo bold italic underline fontsize forecolor | bullist emoticons | copy paste pastetext | link image media',
                contextmenu: false,//'paste | link image inserttable | cell row column deletetable | spellchecker',
                content_css: false,
                browser_spellcheck: true,
                skin: false,
                content_style: contentUiCss.toString() + '\n' + contentCss.toString(),
                automatic_uploads: true,
                smart_paste: true,
                paste_data_images: true,
                paste_preprocess: preProcessPaste,
              }" />
          </div>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="2" class="text-left">
          <v-btn class="ma-2 error eps_white" outlined to="/siteadmin">Cancel</v-btn>
        </v-col>
        <v-col cols="12" sm="4">
          <v-alert type="error" dismissible close-text="Close Alert" border="left" dense v-if="errorMessage"> {{
            errorMessage
          }}
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2" class="text-left">
          <v-btn class="ma-2 teal eps_white" outlined @click="showUploadImage()">
            Attach Image
            <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-camera theme--light"
              style="font-size: 16px"></i>
          </v-btn>
        </v-col>

        <v-col cols="12" sm="2" class="text-right">

          <v-btn class="ma-2 green eps_white" outlined @click="addOrEditNews()">
            Submit
            <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-email-newsletter theme--light"
              style="font-size: 16px"></i>
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row>
        <v-spacer />
        <v-col cols="10" md="10">
          <v-row v-if="newsImages && newsImages.length > 0">
            <v-card width="100%">
              <v-card-title width="100%">
                <h2>Images</h2>
              </v-card-title>
              <v-row>
                <v-col cols="12" md="6" v-for="(image, index) in newsImages" :key="index">
                  <v-card :loading="image.loading">
                    <v-card-title style="align-items: start">
                      <v-text-field clearable outlined :rules="[rules.required]" shaped
                        label="Provide a caption for your image" v-model="image.imageCaption">
                      </v-text-field>
                      <v-card-actions class="pa-0 ma-0">
                        <v-btn :loading="image.loadingLeft" class="ma-2 info eps_white" outlined
                          @click="rotateImage(image, -90)" alt="Rotate Left"><i aria-hidden="true"
                            class="v-icon notranslate v-icon--center mdi mdi-rotate-left theme--light"
                            style="font-size: 16px"></i>
                        </v-btn>
                        <v-btn :loading="image.loadingRight" class="ma-2 info eps_white" outlined
                          @click="rotateImage(image, 90)" alt="Rotate Right"><i aria-hidden="true"
                            class="v-icon notranslate v-icon--center mdi mdi-rotate-right theme--light"
                            style="font-size: 16px"></i>
                        </v-btn>
                        <v-btn class="ma-2 error eps_white" outlined @click="newsImages.pop(image)" alt="Remove Image">
                          <i aria-hidden="true" class="v-icon notranslate v-icon--center mdi mdi-delete theme--light"
                            style="font-size: 16px"></i>
                        </v-btn>
                      </v-card-actions>
                    </v-card-title>
                    <v-card elevation="6" widht="100%">
                      <v-img class="ml-auto" outlined :src="getImageFullUrl(image.imageUrl)" />
                    </v-card>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
          <v-spacer />
        </v-col>
        <v-spacer />
      </v-row>


      <v-dialog v-model="showUploadImageDialog">
        <v-card :loading="imageUploading">
          <v-text-field class="ml-2 mr-2 pt-2" clearable outlined :rules="[rules.required]" shaped persistent-hint
            label="Describe your image" hint="No more than 200 characters" counter="200" v-model="imageCaption">
          </v-text-field>
          <v-file-input class="ml-2 mr-2" outlined small-chips show-size accept="image/*" label="Select Image"
            v-model="rawFile" change="await imageChanged()">
          </v-file-input>
          <v-row class="ml-1 mr-1">
            <v-col cols="6">
              <v-btn class="ma-0 error eps_white" outlined @click="closeUploadImageDialog()">Cancel
                <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-cancel theme--light"
                  style="font-size: 16px"></i>
              </v-btn>
              <v-spacer />
            </v-col>
            <v-col cols="6" class="text-right">
              <v-spacer />
              <v-btn class="ma-0 teal eps_white" outlined @click="uploadImage()" :loading="imageUploading">Upload<i
                  aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-camera theme--light"
                  style="font-size: 16px"></i></v-btn>
            </v-col>
            <v-col cols="12">
              <v-alert dismissible close-text="Close Alert" border="left" v-if="uploadImageMessage"
                :type="uploadImageStatus">
                {{ uploadImageMessage }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

    </v-container>
  </v-form>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import contentUiCss from "!!raw-loader!tinymce/skins/ui/oxide/content.css";
import contentCss from "!!raw-loader!tinymce/skins/content/default/content.css";

import "tinymce/tinymce";
// /* A theme is also required */
import "tinymce/themes/silver/theme.min.js";

// /* Import the skin */
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

import "tinymce/models/dom/model";

import "tinymce/icons/default";

/* Import plugins */
import "tinymce/plugins/advlist";
import "tinymce/plugins/lists";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/anchor";
import "tinymce/plugins/media";

import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";
import forumFunctions from "@/functions/forumFunctions";


export default {
  components: {
    editor: Editor,
  },
  data: () => ({
    errorMessage: null,
    newsId: null,
    currentNewsObject: null,
    plugins: [],
    dialog: true,
    newsArticleTitle: "",
    contentUiCss: contentUiCss,
    contentCss: contentCss,
    editorContent: "",
    newsImages: [],
    imagesToPurge: [],
    showUploadImageDialog: false,
    imageUploading: false,
    imageCaption: null,
    rawFile: null,
    newImageBase64: null,
    uploadImageSucceeded: null,
    uploadImageMessage: null,
    newImage: null,
    rules: {
      required: (value) => !!value || "Required",
    },
    titleRules: [
      v => !!v || 'Title is required',
      v => (v && v.length <= 150) || 'Title must be less than 150 characters',
    ],

  }),
  computed: {
    addOrEditLabel() {
      return (this.newsId) ? "Edit" : "Add";
    },
    uploadImageStatus() {
      return this.uploadImageSucceeded ? "success" : "error";
    },
  },
  methods: {
    getImageFullUrl(imagePath) {
      return forumFunctions.getImageFullUrl(imagePath);
    },
    async imageChanged() {
      this.newImageBase64 = await this.readBase64Image(this.rawFile);
    },
    readBase64Image(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result.slice(reader.result.indexOf(",") + 1));
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },
    closeUploadImageDialog() {
      this.imageCaption = null;
      this.uploadImageSucceeded = null;
      this.uploadImageMessage = null;
      this.newImage = null;
      this.newImageBase64 = null;
      this.rawFile = null;
      this.imageUploading = false;
      this.showUploadImageDialog = false;
    },
    showUploadImage() {
      this.showUploadImageDialog = true;
    },
    async uploadImage() {
      this.uploadImageSucceeded = null;
      this.uploadImageMessage = null;

      if (!this.rawFile) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage = "Please Select An Image";
        return;
      }

      this.newImage = this.rawFile;

      this.newImageBase64 = await this.readBase64Image(this.rawFile);

      if (this.newImageBase64.length > 5 * 1000 * 1000) {
        await this.resizeBase64Img(this.rawFile);
      }

      if (!this.newImage || !this.newImageBase64) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage = "Please Select An Image";
        return;
      }
      let uploadImageRequest = serverFunctions.getUploadImageRequest(
        userFunctions.getLoggedInUser(),
        this.newImage.name,
        this.newImage.type,
        this.newImageBase64
      );

      this.imageUploading = true;

      let uploadImageResponse = null;

      try {
        uploadImageResponse = await serverFunctions.getPostResponse(
          "/uploadImage",
          uploadImageRequest
        );
      } catch (exception) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage =
          "Image upload failed. Please check your connection and try again";
        this.imageUploading = false;
        return;
      }

      if (
        !uploadImageResponse ||
        uploadImageResponse.length == 0 ||
        !uploadImageResponse[0].success
      ) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage =
          "Image upload failed. Please check your connection and try again";
        this.imageUploading = false;
        return;
      }

      this.uploadImageSucceeded = uploadImageResponse[0].success;

      this.uploadImageMessage = this.uploadImageSucceeded
        ? "Image Uploaded"
        : uploadImageResponse[0].failureReason;

      if (this.uploadImageSucceeded) {
        this.newsImages.push({
          imageCaption: this.imageCaption,
          imageUrl: uploadImageResponse[0].imagePathAndFilename,
          loading: false,
        });
        this.closeUploadImageDialog();
      }
      this.imageUploading = false;
    },
    async resizeBase64Img(base64) {

      var canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      var image;

      const loadImagePromise = new Promise((resolve) => {
        image = new Image();
        image.onload = function () {
          let maxHeight = 800;
          let maxWidth = 800;
          var height = image.height;
          var width = image.width;

          let imageOverMaxHeight = height / maxHeight;
          let imageOverMaxWidth = width / maxWidth;

          if (imageOverMaxHeight > 1 && imageOverMaxHeight >= imageOverMaxWidth) {
            height *= 1 / imageOverMaxHeight;
            width *= 1 / imageOverMaxHeight;
          }

          if (imageOverMaxWidth > 1 && imageOverMaxWidth >= imageOverMaxHeight) {
            height *= 1 / imageOverMaxWidth;
            width *= 1 / imageOverMaxWidth;
          }

          canvas.height = height;
          canvas.width = width;
          context.drawImage(
            image,
            0,
            0,
            image.width,
            image.height, // source rectangle
            0,
            0,
            canvas.width,
            canvas.height
          );
          resolve();
        };
        image.src = URL.createObjectURL(base64);
      });
      await loadImagePromise;
      let reducedImageBase64 = canvas.toDataURL(base64.type, 1);
      this.newImageBase64 = reducedImageBase64.slice(reducedImageBase64.indexOf(",") + 1);
    },
    async rotateImage(image, degrees) {
      image.loading = true;
      degrees < 0 ? (image.loadingLeft = true) : (image.loadingRight = true);

      let rotateImageRequest = serverFunctions.getRotateImageRequest(
        userFunctions.getLoggedInUser(),
        image.imageUrl,
        degrees
      );

      let rotateImageResponse = await serverFunctions.getPostResponse(
        "/rotateImage",
        rotateImageRequest
      );

      if (rotateImageResponse[0].success) {
        this.imagesToPurge.push(image.imageUrl);
        image.imageUrl = rotateImageResponse[0].uploadedFileAndPathWithoutServer;
      }
      image.loading = false;
      image.loadingLeft = false;
      image.loadingRight = false;
    },
    preProcessPaste(plugin, args) {

      this.errorMessage = null;

      let url = args.content;

      if (url.indexOf("blob:") <= 0) {
        return; //not a blob, continue
      }

      args.stopImmediatePropagation();
      args.stopPropagation();
      args.preventDefault();

      let start = url.indexOf("src=") + 5;
      let end = url.lastIndexOf("\"");
      url = url.substring(start, end);

      let blob = fetch(url).then(r => r.blob());
      let maxAlowableSize = 250000; //250kb, qtr of a meg
      var pastedImageSize = -1;

      Promise.all([blob]).then((value) => {
        pastedImageSize = value[0].size

        if (pastedImageSize <= maxAlowableSize) {
          if (args.content) {
            if (this.editorContent == null) {
              this.editorContent = ""
            }
            this.editorContent += args.content
          } else {
            this.editorContent = "";
          }
        } else {
          this.errorMessage = "The image you're pasting into the window is too large to paste. Consider uploading it to a file sharing site and using the 'insert image' icon in the toolbar"
        }

      });
    },
    addOrEditNews() {

      if (!this.newsId || !this.currentNewsObject) {

        let title = this.newsArticleTitle;
        let content = this.editorContent;
        let images = this.newsImages;

        let newsRequest = serverFunctions.getNewNewsRequest(userFunctions.getLoggedInUser(), title, content, images);

        serverFunctions.getPostResponse("/addNews", newsRequest);

        this.$router.push("/siteadmin");
      }
      else {

        this.currentNewsObject[0].title = this.newsArticleTitle
        this.currentNewsObject[0].content = this.editorContent
        this.currentNewsObject[0].images = this.newsImages

        let newsRequest = serverFunctions.getUpdateNewsRequest(userFunctions.getLoggedInUser(), this.currentNewsObject[0]);

        serverFunctions.getPostResponse("/updateNews", newsRequest);

        this.$router.push("/siteadmin");

      }
    },
    async loadNewsObject() {
      if (!this.newsId) {
        return;
      }

      let getNewsRequest = serverFunctions.getDataRequestObject(userFunctions.getLoggedInUser(), this.newsId);

      this.currentNewsObject = await serverFunctions.getPostResponse("/getNews", getNewsRequest);

      this.newsArticleTitle = this.currentNewsObject[0].title
      this.editorContent = this.currentNewsObject[0].content
      this.newsImages = this.currentNewsObject[0].images

    },
    focusEditor(e) {
      e.target.selection.select(e.target.getBody(), true);
      e.target.selection.collapse(false);
      e.target.selection.scrollIntoView();
      e.target.focus();
    },
  },
  beforeMount() {
    this.newsId = this.$route.params.newsId;
  },
  mounted() {
    if (this.newsId) {
      this.loadNewsObject()
    }
    this.$refs.userForm.validate();
  },
};
</script>

<style>
.ck .ck-editor__editable_inline {
  min-height: 400px;
  height: 400px;
}
</style>